// extracted by mini-css-extract-plugin
export default {"containerservicos":"Servicos_containerservicos__c2ehq","servicosbox":"Servicos_servicosbox__HhvSl","servicosboxdesc":"Servicos_servicosboxdesc__2tHa3"};